var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-families-show-view"
  }, [(_vm.isLoading) ? _c('loader') : _vm._e(), _vm._v(" "), (_vm.isSuccessfullyLoaded) ? _c('div', [_c('div', {
    staticClass: "action-buttons-container"
  }, [_c('div', {
    staticClass: "action-buttons"
  }, [_c('link-button', {
    attrs: {
      "to": {
        name: 'edit-product-family',
        params: {
          id: _vm.productFamily.id
        }
      },
      "icon": "pencil"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.edit')))]), _vm._v(" "), _c('link-button', {
    attrs: {
      "to": {
        name: 'product-family-revisions',
        params: {
          id: _vm.productFamily.id
        }
      },
      "icon": "future"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.editRevisions')))]), _vm._v(" "), _c('common-button', {
    attrs: {
      "con": "trash",
      "type": "danger"
    },
    on: {
      "click": _vm.deleteProductFamilyWhenConfirmed
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.delete')))])], 1), _vm._v(" "), (_vm.hasActiveRevision) ? _c('div', {
    staticClass: "active-revision-indicator"
  }, [_c('icon', {
    attrs: {
      "name": "check"
    }
  }), _vm._v(" "), _c('b', [_vm._v(" " + _vm._s(_vm.$t('hints.activeRevision')) + " ")])], 1) : _vm._e()]), _vm._v(" "), (_vm.productFamily.bundle) ? _c('h3', [_vm._v(_vm._s(_vm.$t('headlines.bundledFamilies')))]) : _vm._e(), _vm._v(" "), (_vm.productFamily.bundle) ? _c('product-family-bundling-manager', {
    attrs: {
      "product-family": _vm.productFamily
    }
  }) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('headlines.attributes')))]), _vm._v(" "), (_vm.productFamily.bundle) ? _c('attribute-table', {
    attrs: {
      "data": _vm.productFamily,
      "fields": ['type', 'name', 'familyNumber', 'insertedAt', 'updatedAt']
    },
    scopedSlots: _vm._u([{
      key: "insertedAt",
      fn: function(insertedAt) {
        return [_c('timeago', {
          attrs: {
            "auto-update": 60,
            "since": insertedAt.value
          }
        })]
      }
    }, {
      key: "updatedAt",
      fn: function(updatedAt) {
        return [_c('timeago', {
          attrs: {
            "auto-update": 60,
            "since": updatedAt.value
          }
        })]
      }
    }])
  }, [_c('template', {
    slot: "type"
  }, [_vm._v(_vm._s(_vm.$t('types.bundle')))])], 2) : _c('attribute-table', {
    attrs: {
      "data": _vm.productFamily,
      "fields": ['type', 'brand', 'model', 'familyNumber', 'selectors',
        'insertedAt', 'updatedAt'
      ]
    },
    scopedSlots: _vm._u([{
      key: "brand",
      fn: function(brand) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'edit-brand',
              params: {
                id: brand.value.id
              }
            }
          }
        }, [_vm._v(_vm._s(brand.value.name))])]
      }
    }, {
      key: "insertedAt",
      fn: function(insertedAt) {
        return [_c('timeago', {
          attrs: {
            "auto-update": 60,
            "since": insertedAt.value
          }
        })]
      }
    }, {
      key: "updatedAt",
      fn: function(updatedAt) {
        return [_c('timeago', {
          attrs: {
            "auto-update": 60,
            "since": updatedAt.value
          }
        })]
      }
    }])
  }, [_c('template', {
    slot: "type"
  }, [_vm._v(_vm._s(_vm.$t('types.standard')))]), _vm._v(" "), _c('template', {
    slot: "selectors"
  }, [_c('separated-list', {
    attrs: {
      "items": _vm.selectors
    }
  })], 1)], 2), _vm._v(" "), (_vm.productFamily.categories.length) ? [_c('h3', [_vm._v(_vm._s(_vm.$t('headlines.productCategories', {
    count: _vm.productFamily.categories.length
  })))]), _vm._v(" "), _c('product-category-assignment-table', {
    attrs: {
      "product-categories": _vm.productFamily.categories,
      "show-actions": false
    }
  })] : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('headlines.productVariants', {
    count: _vm.variantsCount
  })))]), _vm._v(" "), _c('link-button', {
    attrs: {
      "to": {
        name: _vm.newProductRouteName,
        query: {
          familyId: _vm.id
        }
      },
      "icon": "plus",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.add')))]), _vm._v(" "), (_vm.productFamily.bundle) ? _c('common-button', {
    attrs: {
      "disabled": _vm.productFamily.bundlings.length <= 1
    },
    on: {
      "click": function($event) {
        _vm.$refs.bundleWizard.show()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.bundleWizard')))]) : _vm._e(), _vm._v(" "), (_vm.productFamily.bundle) ? _c('bundle-wizard', {
    ref: "bundleWizard",
    attrs: {
      "product-family": _vm.productFamily
    },
    on: {
      "update": function($event) {
        _vm.$emit('reload-product-family')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasVariants) ? _c('product-table', {
    attrs: {
      "products": _vm.productFamily.products,
      "use-variant-names": ""
    }
  }) : _c('div', {
    staticClass: "uk-placeholder uk-text-center"
  }, [_c('icon', {
    staticClass: "uk-margin-small-right",
    attrs: {
      "name": "warning"
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t('hints.noVariants')) + "\n    ")], 1)], 2) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35b5e02f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/ProductFamilies/ShowView.vue
// module id = 1926
// module chunks = 0